export function isEven(n) {
    return n % 2 === 0;
}
export function stripHtmlTags(text) {
    const doc = new DOMParser().parseFromString(text, 'text/html');
    return doc.body.textContent || '';
}
